import { graphql } from "gatsby"
import isEmpty from "~/lib/isEmpty"

export type ColorMaskComponent = {
  __typename: string
  color?: string
  opacity?: number
}

const HEX_PATTERN = /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/

export type ColorMaskStyle = {
  backgroundColor: string
  opacity: number
}

/**
 * Turns the editor-entered mask into an overlay style, or `null` when it can't
 * be drawn. The HEX may come with or without `#`; opacity is a 0–100 percentage
 * and is clamped, so a value that slipped past CMS validation never renders wrong.
 */
export function getColorMaskStyle(
  mask?: ColorMaskComponent | null
): ColorMaskStyle | null {
  if (isEmpty(mask) || isEmpty(mask.color) || mask.opacity == null) {
    return null
  }

  const hex = mask.color.trim()

  if (!HEX_PATTERN.test(hex)) {
    return null
  }

  return {
    backgroundColor: hex.startsWith("#") ? hex : `#${hex}`,
    opacity: Math.min(100, Math.max(0, mask.opacity)) / 100,
  }
}

export const query = graphql`
  fragment ColorMask on GraphCmsSquidex_ColorMaskComponent {
    __typename
    color
    opacity
  }
`

export const FRAGMENT_COLOR_MASK = `
  fragment ColorMask on ColorMaskComponent {
    __typename
    color
    opacity
  }
`
